module.exports = __webpack_public_path__ + "static/media/template.03d67db2.svg";